import React, { Component, createRef } from 'react'
import { Link } from 'react-router-dom'
import { routePrefix } from '../../config'
import backArrow from '../../images/dayViewBackArrow.svg'
import forwardArrow from '../../images/forwardArrow.svg'
import moment from 'moment'
import { connect } from 'react-redux'
import * as actions from '../../containers/inventoryView/actions'
import TablePagination from '../../components/common/tablePagination'


class RejectionReasons extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef()
    this.state = {
      pageNum: 1,
      paginationLimit: 10,
    }
  }
  

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const date = localStorage.getItem('selected-date');
    const route_id = localStorage.getItem('route-id')
    this.props.fetchRejectionReasons(date, route_id);
  }

  onPrevClick = () => {
    this.myRef.current.scrollIntoView()
    this.setState({ pageNum: this.state.pageNum - 1 });
  }

  onNextClick = () => {
    // if page data is available just increase the page num count
    this.myRef.current.scrollIntoView()
    const serviceData = this.props.rejectionReasons && this.props.rejectionReasons.service_data;
    if (serviceData && serviceData.length > this.state.pageNum * this.state.paginationLimit) {
      this.setState({ pageNum: this.state.pageNum + 1 });
      return;
    }
  }

  renderReasons(el) {
    let result;
    const { rejectionReasons } = this.props;
    const dataToMapReasons = rejectionReasons && rejectionReasons.reject_reason_map;
    const reasonsList = el.rejected_reasons;
    result = reasonsList.map((item, index) => {
      if (item) {
        return (
          <div className='reasonText' key={index}>
            <span className='reason'>{`REASON ${item} : `}</span>
            {`${dataToMapReasons[item]}`}
          </div>
        )
      }
    })
    return result;
  }

  render() {
    const date = localStorage.getItem('selected-date');
    const route = localStorage.getItem('selected-route');
    const { rejectionReasons } = this.props;
    const { paginationLimit } = this.state;
    const serviceData = rejectionReasons && rejectionReasons.service_data;
    let startIndex = (this.state.pageNum - 1) * paginationLimit;
    let endIndex = (this.state.pageNum) * 1 * paginationLimit;
    return (
      <div className='rejectionReasonsContainer' ref={this.myRef}>
        <div>
          <Link to={routePrefix + '/inventory-view/daylevel'}>
            <div className="headerLhs">
              <img className="backIcon" src={backArrow} alt="icon" />
              <span className="headerTextReasonsView">{moment(date).format('dddd, MMMM DD, yyyy')}</span>
              <img className="forwardIcon" src={forwardArrow} alt="icon" />
              <span className="routeHeader">{route}</span>
            </div>
          </Link>
        </div>
        <div className='tableContainer'>
          <table className="app-table">
            <thead>
              <tr className="payout-table-header">
                <th>Service ID</th>
                <th>Trip ID</th>
                <th>Rejected Reasons</th>
              </tr>
            </thead>
            <tbody>
              {
                (!serviceData || !serviceData.length) && <tr><td colSpan={9} className="table-no-data">No Data Found</td></tr>
              }
              {
                serviceData && serviceData.slice(startIndex, endIndex).map((el, i) => (
                  <tr key={i} className="payout-table-row">
                    <td className='serviceId'>{el.svc_id}</td>
                    <td className='tripId'>{el.trip_id}</td>
                    <td>{this.renderReasons(el)}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
          {
            (serviceData && Boolean(serviceData.length)) &&
            <div className='pagination'>
              <TablePagination
                pageNum={this.state.pageNum}
                dataLength={serviceData && serviceData.length}
                onPrevClick={this.onPrevClick}
                onNextClick={this.onNextClick}
                isInventoryView={false}
                paginationLimit={paginationLimit}
              />
            </div>
          }


        </div>
      </div>
    )
  }
}

const mapStateToProps = store => ({
  rejectionReasons: store.inventoryViewReducer.rejectionReasons,

})

const mapDispatchToProps = dispatch => ({
  fetchRejectionReasons: (date, route_id) => dispatch(actions.fetchRejectionReasons(date, route_id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RejectionReasons)
